import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'
import { makeStyles, Box, Button, Tooltip, Typography } from '@material-ui/core'

import { CloseIcon } from '../../../modules/icons'

const useHintTooltipStyles = makeStyles(theme => ({
  popper: {
	zIndex: 2,
	width: 300
  },
  tooltip: {
	position: 'relative',
	padding: theme.spacing(1, 1.75, 1, 1.5),
	backgroundColor: theme.palette.primary.main,
	overflow: 'visible',
	pointerEvents: 'all'
  },
  arrow: {
	color: theme.palette.primary.main,
  },
  inner: {
	cursor: 'default',
	userSelect: 'none',
  },
  title: {
	// display: 'inline',
	fontWeight: 'bold',
	textTransform: 'uppercase',
  },
  body: {
	// display: 'inline',
  },
  close: {
	position: 'absolute',
	top: 0,
	right: 0,
	padding: theme.spacing(0.75),
	minHeight: 'unset',
	backgroundColor: 'transparent',
	minWidth: 0,
	'& svg': {
		fontSize: '1rem',
		color: 'white',
	},
	'&:hover': {
		backgroundColor: 'transparent',
		'& svg': {
			color: theme.palette.text.primary,
		},
	}
  }
}))

const HintTooltip = forwardRef(({ title, body, open, onClose, children, ...props }, ref) => {
	const classes = useHintTooltipStyles()
	return (
		<Tooltip
			ref={ref}
			placement='right'
			arrow={true}
			open={Boolean(open)}
			className={classes.root}
			classes={{
				popper: classes.popper,
				tooltip: classes.tooltip,
				arrow: classes.arrow,
			}}
			title={
				<Box
					className={classes.inner}
				>
					{title ?
						<Typography
							className={classes.title}
							component='div'
						>
							{title}:&nbsp;
						</Typography>
					: null}
					<Typography
						className={classes.body}
						component='div'
					>
						{body}
					</Typography>
					<Button
						onClick={onClose}
						className={classes.close}
					>
						<CloseIcon />
					</Button>
				</Box>
			}
			{...props}
		>
			{children}
		</Tooltip>
	)
})

HintTooltip.propTypes = {
  /** Title text string */
  title: PropTypes.string,
  /** Body text string */
  body: PropTypes.string,
  /** Type key */
  type: PropTypes.string,
  /** Open boolean */
  open: PropTypes.bool,
  /** Close callback */
  onClose: PropTypes.func,
}

HintTooltip.displayName = 'HintTooltip'

export default HintTooltip